import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  speedTypes: PropTypes.oneOfType([PropTypes.array]).isRequired,
  scrollPos: PropTypes.number.isRequired,
};

const defaultProps = {
  children: null,
};

const SPEEDVALUES = new Map([
  ['slow', 0.25],
  ['normal', 0.3],
  ['fast', 0.4],
  ['faster', 0.6],
  ['superFaster', 0.9],
]);

export default class UpdateLayerMovementSpeed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slow: -0.1,
      normal: -0.1,
      fast: -0.1,
      faster: -0.1,
      superFaster: -0.1,
    };
  }

  componentDidUpdate(prevProps) {
    const { scrollPos } = this.props;

    if (prevProps.scrollPos !== scrollPos) {
      this.updateSpeedLayers(scrollPos);
    }
  }

  updateSpeedLayers = scrollPos => {
    const { speedTypes } = this.props;
    let speed;

    for (speed of SPEEDVALUES.keys()) {
      const isSpeedinSpeedTypes = speedTypes.includes(speed);

      if (isSpeedinSpeedTypes) {
        const speedValue = SPEEDVALUES.get(speed);
        const tmpObj = {};

        tmpObj[speed] = -(scrollPos * speedValue);
        this.setState({ ...tmpObj });
      }
    }
  };

  render() {
    const { children, scrollPos } = this.props;
    const newChildren = React.Children.map(
      children, child => React.cloneElement(child, { speedValues: { ...this.state }, scrollPos }),
    );

    return <>{newChildren}</>;
  }
}

UpdateLayerMovementSpeed.propTypes = propTypes;
UpdateLayerMovementSpeed.defaultProps = defaultProps;
